<script>
import Vue from 'vue';
import Component from 'vue-class-component';

@Component
export default class ActionBase extends Vue {
  useMenu() {
    const breakPoint = this.$vuetify.breakpoint.name;
    return (breakPoint === 'xs' || breakPoint === 'sm');
  }
}
</script>
